<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style=" overflow: auto;padding-bottom: 53px;"
  >
    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span
          style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height:20px;width:20px;border:0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="UserId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入用户UserId"
            v-decorator.trim="['userId', validatorRules.userId]"
            :readOnly="!!model.id"
          />
        </a-form-item>

        <template v-if="!model.id">
          <a-form-item
            label="成员名称"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              type="text"
              placeholder="请输入成员名称"
              v-decorator="['name', validatorRules.name]"
            />
          </a-form-item>
        </template>

        <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['gender', {}]"
            placeholder="请选择性别"
            :getPopupContainer="target => target.parentNode"
          >
            <a-select-option value="MALE">男</a-select-option>
            <a-select-option value="FEMALE">女</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            placeholder="请输入邮箱"
            v-decorator="['email', validatorRules.email]"
          />
        </a-form-item>

        <a-form-item
          label="手机号码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            placeholder="请输入手机号码"
            v-decorator="['mobile', validatorRules.mobile]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <depart-window ref="departWindow" @ok="modalFormOk"></depart-window>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import departWindow from '../../system/modules/DepartWindow';
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import { addMember, editUser, queryUserRole, queryall } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';

export default {
  name: 'UserModal',
  components: {
    JImageUpload,
    departWindow,
    JSelectPosition
  },
  data() {
    return {
      departDisabled: false, //是否是我的部门调用该页面
      roleDisabled: false, //是否是角色维护调用该页面
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      resultDepartOptions: [],
      userId: '', //保存用户id
      disableSubmit: false,
      userDepartModel: { userId: '', departIdList: [] }, // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD',
      validatorRules: {
        userId: {
          rules: [{ required: true, message: '请输入UserId!' }]
        },
        name: {
          rules: [{ required: true, message: '请输入成员名称!' }]
        },
        mobile: {
          rules: [
            {
              pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
              message: '请输入正确的手机号码!'
            }
          ]
        },
        email: {
          rules: [
            {
              required: true,
              pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: '请输入正确的邮箱!'
            }
          ]
        }
      },
      departIdShow: false,
      departIds: [], //负责部门id
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      picUrl: '',
      url: {
        // fileUpload: process.env.VUE_APP_GATEWAY_URL + process.env.VUE_APP_CMS_SYSTEM+"/sys/common/upload",
        // userWithDepart: process.env.VUE_APP_CMS_SYSTEM + "/sys/user/userDepartList", // 引入为指定用户查看部门信息需要的url
        // userId:process.env.VUE_APP_CMS_SYSTEM + "/sys/user/generateUserId", // 引入生成添加用户情况下的url
        // syncUserByUserName:process.env.VUE_APP_CMS_SYSTEM + "/process/extActProcess/doSyncUserByUserName",//同步用户到工作流
      },
      identity: '1',
      fileList: {}
    };
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { 'X-Access-Token': token };
  },
  computed: {
    uploadAction: function() {
      return this.url.fileUpload;
    }
  },
  methods: {
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    initialRoleList() {
      queryall().then(res => {
        if (res.success) {
          this.roleList = res.result;
        } else {
          console.log(res.message);
        }
      });
    },
    loadUserRoles(userid) {
      queryUserRole({ userid: userid }).then(res => {
        if (res.success) {
          this.selectedRole = res.result;
        } else {
          console.log(res.message);
        }
      });
    },
    refresh() {
      this.selectedDepartKeys = [];
      this.checkedDepartKeys = [];
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.userId = '';
      this.resultDepartOptions = [];
      this.departId = [];
      this.departIdShow = false;
    },
    add() {
      this.picUrl = '';
      this.refresh();
      this.edit({ activitiSync: '1' });
    },
    edit(record) {
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      let that = this;
      that.initialRoleList();
      that.checkedDepartNameString = '';
      that.form.resetFields();
      if (record.hasOwnProperty('id')) {
        that.loadUserRoles(record.id);
        console.log('有id');
        setTimeout(() => {
          this.fileList = record.avatar;
        }, 5);
      }

      that.userId = record.id;
      that.visible = true;
      that.model = Object.assign({}, record);
      this.$nextTick(() => {
        setTimeout(() => {
          that.form.setFieldsValue(
            pick(this.model, 'gender', 'email', 'userId', 'name', 'mobile')
          );
        });
      });

      //身份为上级显示负责部门，否则不显示
      if (this.model.userIdentity == '2') {
        this.identity = '2';
        this.departIdShow = true;
      } else {
        this.identity = '1';
        this.departIdShow = false;
      }
      // 调用查询用户对应的部门信息的方法
      that.checkedDepartKeys = [];
      that.loadCheckedDeparts();
    },
    //
    loadCheckedDeparts() {
      let that = this;
      if (!that.userId) {
        return;
      }
      getAction(that.url.userWithDepart, { userId: that.userId }).then(res => {
        that.checkedDepartNames = [];
        if (res.success) {
          var depart = [];
          var departId = [];
          for (let i = 0; i < res.result.length; i++) {
            that.checkedDepartNames.push(res.result[i].title);
            this.checkedDepartNameString = this.checkedDepartNames.join(',');
            that.checkedDepartKeys.push(res.result[i].key);
            //新增负责部门选择下拉框
            depart.push({
              key: res.result[i].key,
              title: res.result[i].title
            });
            departId.push(res.result[i].key);
          }
          that.resultDepartOptions = depart;
          //判断部门id是否存在，不存在择直接默认当前所在部门
          if (this.model.departIds) {
            this.departIds = this.model.departIds.split(',');
          } else {
            this.departIds = departId;
          }
          that.userDepartModel.departIdList = that.checkedDepartKeys;
        } else {
          console.log(res.message);
        }
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
      this.userDepartModel = { userId: '', departIdList: [] };
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.checkedDepartKeys = [];
      this.selectedDepartKeys = [];
      this.resultDepartOptions = [];
      this.departIds = [];
      this.departIdShow = false;
      this.identity = '1';
      this.fileList = [];
    },
    moment,
    handleSubmit() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = Object.assign(this.model, values);

          let obj;
          if (!this.model.id) {
            formData.id = this.userId;
            obj = addMember(formData);
          } else {
            // obj=editUser(formData);
          }
          obj
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },

    normFile(e) {
      console.log('Upload event:', e);
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    },
    beforeUpload: function(file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      }
      //TODO 验证文件大小
    },
    handleChange(info) {
      this.picUrl = '';
      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }
      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;
        console.log(response);
        if (response.success) {
          this.model.avatar = response.message;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$message.warning(response.message);
        }
      }
    },
    // 搜索用户对应的部门API
    onSearch() {
      this.$refs.departWindow.add(this.checkedDepartKeys, this.userId);
    },

    // 获取用户对应部门弹出框提交给返回的数据
    modalFormOk(formData) {
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.checkedDepartNameString = '';
      this.userId = formData.userId;
      this.userDepartModel.userId = formData.userId;
      this.departIds = [];
      this.resultDepartOptions = [];
      var depart = [];
      for (let i = 0; i < formData.departIdList.length; i++) {
        this.selectedDepartKeys.push(formData.departIdList[i].key);
        this.checkedDepartNames.push(formData.departIdList[i].title);
        this.checkedDepartNameString = this.checkedDepartNames.join(',');
        //新增部门选择，如果上面部门选择后不为空直接付给负责部门
        depart.push({
          key: formData.departIdList[i].key,
          title: formData.departIdList[i].title
        });
        this.departIds.push(formData.departIdList[i].key);
      }
      this.resultDepartOptions = depart;
      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },
    identityChange(e) {
      if (e.target.value === '1') {
        this.departIdShow = false;
      } else {
        this.departIdShow = true;
      }
    }
  }
  // watch:{
  //   'visible':function(newval){
  //     if(newval){
  //       this.form.setFieldsValue(pick(this.model,'username','sex','email','phone','telephone'))
  //     }
  //   }
  // }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
